import axios from "axios"
import { forIn } from "lodash"

export const getBodyFormData = ({
  concepto,
  numeroReferencia,
  precioVenta,
  tipoArticulo,
  camposPersonalizados,
  categoriasId,
  catalogosId,
  FileAsFormFile,
  esDeCompra,
  isEdit,
  id,
  ficheroId,
}: $TSMigrationFixMe) => {
  const bodyFormData = new FormData()

  bodyFormData.append("concepto", concepto)
  bodyFormData.append("numeroReferencia", numeroReferencia)
  bodyFormData.append("precioVenta", precioVenta)
  bodyFormData.append("tipoArticulo", tipoArticulo)
  bodyFormData.append("esDeCompra", esDeCompra)
  categoriasId.forEach((categoriaId: $TSMigrationFixMe) => {
    bodyFormData.append("categoriasId", categoriaId)
  })
  catalogosId.forEach((catalogoId: $TSMigrationFixMe) => {
    bodyFormData.append("catalogosId", catalogoId)
  })

  camposPersonalizados.forEach(
    (campoPersonalizado: $TSMigrationFixMe, index: $TSMigrationFixMe) => {
      forIn(campoPersonalizado, (value, key) => {
        bodyFormData.append(`camposPersonalizados[${index}].${key}`, value)
      })
    }
  )

  if (FileAsFormFile) {
    bodyFormData.append("FileAsFormFile", FileAsFormFile)
  }
  if (isEdit) {
    bodyFormData.append("id", id)

    if (!FileAsFormFile && ficheroId) {
      bodyFormData.append("FicheroId", ficheroId)
    }
  }

  return bodyFormData
}

const ArticuloService = {
  getByNif({
    maxResultCount,
    skipCount,
    NIF,
    concepto,
    categoriasId = [],
    precioVentaLowerLimit,
    precioVentaUpperLimit,
  }: $TSMigrationFixMe) {
    return axios.get(`/Articulo/by-filters-and-nif/${NIF}`, {
      params: {
        maxResultCount,
        skipCount,
        categoriasId,
        concepto,
        precioVentaLowerLimit,
        precioVentaUpperLimit,
      },
    })
  },

  getByFiltersConcepto({
    concepto,
    maxResultCount,
    skipCount,
    precioVentaLowerLimit,
    precioVentaUpperLimit,
    categoriasId = [],
  }: $TSMigrationFixMe) {
    return axios.get(`/Articulo/by-filters`, {
      params: {
        concepto,
        maxResultCount,
        skipCount,
        precioVentaLowerLimit,
        precioVentaUpperLimit,
        categoriasId,
      },
    })
  },

  postMany(articulos: $TSMigrationFixMe) {
    return axios.post(
      `/Articulo/bulk-insert`,
      articulos.map((art: $TSMigrationFixMe) => ({
        ...art,
        tipoArticulo: art.tipoArticulo || 1,
      }))
    )
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Articulo/${id}`)
  },

  getByCategoriaFilters({
    concepto,
    categoriasId = [],
  }: $TSMigrationFixMe = {}) {
    const conceptoParam = concepto ? `Concepto=${concepto}` : ""
    // @ts-expect-error TS(7006): Parameter 'id' implicitly has an 'any' type.
    const categoriasParam = categoriasId.map((id) => `CategoriasId=${id}&`)
      .join``
    const query = `/Articulo/by-filters-grouped-by-categoria?${categoriasParam}${conceptoParam}`
    return axios(query)
  },

  getArticulosGroupedByCategoria({
    catalogoId,
    concepto = "",
    precioVentaLowerLimit = 0,
    precioVentaUpperLimit = 10000000,
    categoriasId = [],
  }: $TSMigrationFixMe = {}) {
    return axios.get(
      `/Articulo/${catalogoId}/by-filters-grouped-by-categoria`,
      {
        params: {
          concepto,
          precioVentaLowerLimit,
          precioVentaUpperLimit,
          categoriasId,
        },
      }
    )
  },

  getArticulosByCatalogoIdEncrypted({
    catalogoId,
    concepto = "",
    precioVentaLowerLimit = 0,
    precioVentaUpperLimit = 10000000,
    categoriasId = [],
  }: $TSMigrationFixMe) {
    return axios.get("/Articulo/shared", {
      params: {
        concepto,
        precioVentaLowerLimit,
        precioVentaUpperLimit,
        categoriasId,
        catalogoIdEncrypted: catalogoId,
      },
    })
  },
}

export default ArticuloService
